export enum FormCriteriaComparator {
    HAS_ANY_OF = 'HAS_ANY_OF',
    HAS_NONE_OF = 'HAS_NONE_OF',
}
